const KEY = "versionReloadAt";
const RETRY_MS = 5 * 60 * 1000;

export async function primePageCache(url) {
	try {
		await fetch(url, { cache: "reload" });
	}
	catch (e) {
		// Offline; the following load falls back to the cache, which
		// is still better than staying on the dead page.
	}
}

export async function reloadForNewVersion() {
	let last;
	try {
		last = Number(sessionStorage.getItem(KEY));
		if (last && Date.now() - last < RETRY_MS) return false;
		sessionStorage.setItem(KEY, String(Date.now()));
	}
	catch (e) {
		// No sessionStorage means no loop guard: do not reload at all.
		return false;
	}
	await primePageCache(location.href);
	location.reload();
	return true;
}

export function clearVersionReloadMark() {
	try {
		sessionStorage.removeItem(KEY);
	}
	catch (e) { /* nothing marked, nothing to do */ }
}
